'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { forwardRef, useMemo, } from 'react';
import { RovingTabIndexProvider } from 'react-roving-tabindex';
import { ConditionalWrapper, Panel, Stack, } from '../../index.js';
import styles from './menu.module.css';
import { MenuItem } from './menu-item/menu-item.js';
import { MenuItemCheckbox } from './menu-item/menu-item-checkbox.js';
import { MenuSeparator } from './menu-separator/menu-separator.js';
export const Menu = forwardRef(({ className, children, maxHeight, wrapWithPanel = true, style, ...otherProps }, forwardedRef) => {
    const dynamicStyle = useMemo(() => ({
        '--max-height': maxHeight,
    }), [maxHeight]);
    return (_jsx(ConditionalWrapper, { condition: wrapWithPanel, wrapper: children => (_jsx(Panel, { bordered: true, vibrant: true, vibrancyColor: "background", showGlow: true, radius: 24, children: children })), children: _jsx(Stack, { as: "ul", ref: forwardedRef, className: clsx(styles.Menu, className), style: { ...dynamicStyle, ...style }, "data-menu-should-scroll": Boolean(maxHeight), vPadding: 8, role: "menu", ...otherProps, children: _jsx(RovingTabIndexProvider, { options: { direction: 'vertical', loopAround: true }, children: children }) }) }));
});
Menu.Item = MenuItem;
Menu.ItemCheckbox = MenuItemCheckbox;
Menu.Separator = MenuSeparator;
